import React from 'react';

function ListView(props: {children: React.ReactNode}) {
    return (
        <div className="molekuls-four-listview">
            {props.children}
        </div>
    );
}

export default ListView;
